import React, { useState } from 'react';
import { ValidatedField } from 'react-jhipster';
import { Alert, Button, Col, Form, ModalBody, ModalFooter, Row } from 'reactstrap';

import { type FieldError, useForm } from 'react-hook-form';

const LoginWidget = (props: ILoginModalProps) => {
  const hostname = window.location.hostname;
  const themeClass = hostname.startsWith('zona') ? 'client-theme' : 'admin-theme';
  const icClient = hostname.startsWith('zona');
  const [loading, setLoading] = useState(false);

  const login = ({ username, password, rememberMe }) => {
    props.handleLogin(username, password, rememberMe);
  };

  const {
    handleSubmit,
    register,
    formState: { errors, touchedFields },
  } = useForm({ mode: 'onTouched' });

  const { loginError } = props;

  const handleLoginSubmit = e => {
    handleSubmit(login)(e);
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <img src={icClient ? 'public/images/logo.png' : 'public/images/nfa_group_logo.png'} alt="Logo" style={{ height: '40px' }} />
      </div>
      <div className={themeClass} style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20%' }}>
        <Form onSubmit={handleLoginSubmit} style={{ minWidth: '300px' }}>
          <ModalBody>
            <Row>
              <Col md="12">
                {loginError ? (
                  <Alert color="danger" data-cy="loginError">
                    <strong>Prihlásenie zlyhalo!</strong> Prosím skontrolujte vaše prihlasovacie údaje a skúste to znovu.
                  </Alert>
                ) : null}
              </Col>
              <Col md="12">
                <ValidatedField
                  name="username"
                  label="E-mail"
                  placeholder="Váš e-mail"
                  required
                  autoFocus
                  data-cy="username"
                  validate={{ required: 'E-mail nemôže byť prázdny!' }}
                  register={register}
                  error={errors.username as FieldError}
                  isTouched={touchedFields.username}
                />
                <ValidatedField
                  name="password"
                  type="password"
                  label="Heslo"
                  placeholder="Vaše heslo"
                  required
                  data-cy="password"
                  validate={{ required: 'Heslo nemôže byť prázdne!' }}
                  register={register}
                  error={errors.password as FieldError}
                  isTouched={touchedFields.password}
                />
                <ValidatedField name="rememberMe" type="checkbox" check label="Zapamätať" value={true} register={register} />
              </Col>
            </Row>
            <div className="mt-1">&nbsp;</div>
            {/*<Alert color="warning">*/}
            {/*  <Link to="/account/reset/request" data-cy="forgetYourPasswordSelector">*/}
            {/*    Zabudli ste heslo?*/}
            {/*  </Link>*/}
            {/*</Alert>*/}
            {/*<Alert color="warning">*/}
            {/*  <span>Ešte nemáte účet?</span> <Link to="/account/register">Zaregistrujte si nový účet.</Link>*/}
            {/*</Alert>*/}
          </ModalBody>
          <ModalFooter>
            <Button
              style={{ backgroundColor: '#e31818' }}
              disabled={loading}
              label="Prihlásiť sa"
              type="submit"
              className="w-100 p-button-outlined"
            >
              Prihlásiť sa
            </Button>
          </ModalFooter>
        </Form>
      </div>
    </>
  );
};

export interface ILoginModalProps {
  loginError: boolean;
  handleLogin: (username: string, password: string, rememberMe: boolean) => void;
}

export default LoginWidget;
